import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const MiniBus = () => {
  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Mini Bus Rental</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>Mini Bus Services by eTravo</h1>

        <p style={styles.paragraph}>
          eTravo proudly offers Mini Bus rentals that cater to medium and large group travel with maximum 
          comfort and convenience. Whether it's a school picnic, corporate retreat, wedding function, or 
          pilgrimage tour — our fleet of well-equipped Mini Buses ensures a smooth and enjoyable ride for all passengers.
        </p>

        <h2 style={styles.subHeader}>Available Variants:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>18-Seater:</strong> Perfect for family and corporate groups</li>
          <li style={styles.listItem}><strong>21-Seater:</strong> Best suited for wedding events and outstation tours</li>
          <li style={styles.listItem}><strong>26-Seater:</strong> Ideal for large team outings and religious trips</li>
        </ul>

        <h2 style={styles.subHeader}>Top Features:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Air-Conditioned & Non-AC Options</li>
          <li style={styles.listItem}>High-back Pushback Seats</li>
          <li style={styles.listItem}>Onboard Entertainment (TV, Music System)</li>
          <li style={styles.listItem}>Spacious Aisle & Luggage Room</li>
          <li style={styles.listItem}>Curtains & Reading Lights</li>
          <li style={styles.listItem}>Trained Drivers & Assistants</li>
        </ul>

        <h2 style={styles.subHeader}>Why Rent a Mini Bus from eTravo?</h2>
        <p style={styles.paragraph}>
          At <strong>eTravo</strong>, we combine comfort, affordability, and reliability in every trip.
          Our Mini Bus rentals are designed to serve all your medium-sized group transportation needs, with
          well-maintained vehicles, punctual service, and flexible travel plans.
        </p>

        <p style={styles.paragraph}>
          Whether it’s a short city transfer or a long inter-state journey, we offer competitive rates and
          unmatched customer service. Your safety, comfort, and satisfaction are our top priorities.
        </p>

        <h2 style={styles.subHeader}>Pricing & Packages:</h2>
        <p style={styles.paragraph}>
          Starting at just <strong>₹20/km</strong> with daily and long-term rental options available. Contact
          us for tailored quotes depending on your destination and duration.
        </p>

        <h2 style={styles.subHeader}>Trusted by 1,000+ Happy Travelers</h2>
        <p style={styles.paragraph}>
          eTravo has successfully served families, companies, schools, and event organizers with quality Mini Bus services.
          We take pride in our punctuality, cleanliness, and dedicated travel support.
        </p>

        <h2 style={styles.subHeader}>Book Your Mini Bus Today!</h2>
        <p style={styles.paragraph}>
          Ready to hit the road with your group? Contact eTravo today for seamless, affordable, and stress-free Mini Bus rentals. 
          Call us now or book online in just a few clicks.
        </p>
      </div>
    </>
  );
};

export default MiniBus;
